const state = {
    confirmEmail: '',
    sendByEmail: false,
    sendBySMS: false,
    profileIdentityState: '',
    patientDataToFillMetadataForm: undefined,
};

const getters = {
    getSendByEmail: (state) => {
        return state.sendByEmail;
    },
    getSendBySMS: (state) => {
        return state.sendBySMS;
    },
    getConfirmEmail: (state) => {
        return state.confirmEmail;
    },
    getProfileIdentityState: (state) => {
        return state.profileIdentityState;
    },
    getPatientDataToFillMetadataForm: (state) => {
        return state.patientDataToFillMetadataForm;
    },
};

const mutations = {
    SET_PATIENT_DATA_TO_FILL_METADATA_FORM(state, patient) {
        state.patientDataToFillMetadataForm = patient;
    },
    SET_CONFIRM_EMAIL(state, confirmEmail) {
        state.confirmEmail = confirmEmail;
    },
    SET_SEND_BY_EMAIL(state, sendByEmail) {
        state.sendByEmail = sendByEmail;
    },
    SET_SEND_BY_SMS(state, sendBySMS) {
        state.sendBySMS = sendBySMS;
    },
    SET_PROFILE_IDENTITY_STATE(state, profileIdentityState) {
        state.profileIdentityState = profileIdentityState;
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
